export type Theme = "light" | "dark";
export const THEME_STORAGE_KEY = "cyprus-trees.theme";

export function initialTheme(): Theme {
  try {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch { /* Continue with the document or operating-system preference. */ }
  const applied = document.documentElement.dataset.theme;
  if (applied === "light" || applied === "dark") return applied;
  return typeof window.matchMedia === "function" && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(theme: Theme, persist = true): void {
  document.documentElement.dataset.theme = theme;
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute("content", theme === "dark" ? "#111A15" : "#E4E7E1");
  if (persist) {
    try { window.localStorage.setItem(THEME_STORAGE_KEY, theme); } catch { /* Storage is optional. */ }
  }
}
